import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, ReplaySubject, tap, of } from 'rxjs';

import { environment } from 'environments/environment';

/** Fuse */
import { Navigation } from './navigation.types';
import { FuseNavigationItem } from '@fuse/components/navigation';

/** Servicio */
import { AuthService } from '../auth/auth.service';

/** Interface */
import { ResponseRest } from 'app/interface/response-rest';
import { AuthMenu } from 'app/module-auth/domain/auth/auth-menu';

@Injectable({ providedIn: 'root' })
export class NavigationService {

    /**propiedad url */
    private url: string = environment.urlAuth + "/Account";

    private _httpClient = inject(HttpClient);
    private _authService = inject(AuthService);

    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    defaultNavigation: any[] = [
        { id: 'example', title: 'Home', type: 'basic', icon: 'heroicons_outline:home', link: '/home' }
    ];

    get navigation$(): Observable<Navigation> {
        return this._navigation
            .asObservable();
    }


    get(): Observable<Navigation> {

        //Valida Aplicación
        const group = environment.ApiKey;
        const application = this._authService.session?.Application;
        if (application != null) {

            let url = `${this.url}/menu?group=${group}&application=${application}`;

            return this._httpClient
                .get<ResponseRest>(url)
                .pipe(
                    tap((navigation: any) => {
                        const menu = this.generateMenu(navigation.Data);
                        this._navigation.next(menu);
                    }),
                );

        } else {
            const menu: Navigation =
            {
                default: this.defaultNavigation,
                compact: this.defaultNavigation,
                futuristic: this.defaultNavigation,
                horizontal: this.defaultNavigation
            }

            let url = `${this.url}/menu?group=${group}&application=00000000-0000-0000-0000-000000000000`;
            return this
                ._httpClient
                .get<Navigation>(url)
                .pipe(
                    tap((navigation) => {

                        this._navigation.next(menu);
                        //this._navigation.next(navigation);
                    }),
                );
        }




    }

    getApplication(application: string): Observable<any> {

        const group = environment.ApiKey;
        let url = `${this.url}/menu?group=${group}&application=${application}`;
        return this._httpClient
            .get<ResponseRest>(url)
            .pipe(
                tap((navigation: ResponseRest) => {
                    const menu = this.generateMenu(navigation.Data);
                    this._navigation.next(menu);
                }),
            );

    }

    private generateMenu(menu: AuthMenu[]): Navigation {

        const navigation: Navigation = {
            compact: [],
            default: [],
            futuristic: [],
            horizontal: []
        };

        //this.navigationPemision = [];

        menu.forEach((item) => {

            let parent: FuseNavigationItem = {
                id: item.id.toString(),
                icon: item.icon,
                title: item.title,
                type: 'basic',
                subtitle: item.subtitle,
                link: item.link,
            };

            if (item.type == 'group') { parent.type = 'group'; }

            if (item.type == 'basic') {
                parent.type = 'basic';
                //this.navigationPemision.push({ id: item.key, actions: item.actions });
            };

            if (item.type == 'collapsable') { parent.type = 'collapsable'; }

            parent = this.chids(item, parent);

            navigation.compact.push(parent);
            navigation.default.push(parent);
            navigation.futuristic.push(parent);
            navigation.horizontal.push(parent);
        });

        return navigation;

    }

    private chids(item: any, parent: FuseNavigationItem): FuseNavigationItem {


        if (item.children != null && item.children.length >= 0) {

            parent.children = [];

            item.children.forEach((itemchild) => {

                let child: FuseNavigationItem = {
                    id: itemchild.id,
                    icon: itemchild.icon,
                    title: itemchild.title,
                    type: 'basic',
                    subtitle: itemchild.subtitle,
                    link: itemchild.link
                };

                if (itemchild.type === 'group') { child.type = 'group'; }
                if (itemchild.type === 'basic') {
                    child.type = 'basic';
                    //this.navigationPemision.push({ id: itemchild.key, actions: itemchild.actions });
                };
                if (itemchild.type === 'collapsable') { child.type = 'collapsable'; }

                child = this.chids(itemchild, child);

                parent.children.push(child);
            });
        }
        return parent;
    }

}


